// Adapté de ScanGabon/apps/capture/src/outils/octets.ts, lecture du 24 octobre 2026.
// Reprise locale pour CollectivitésConnect ; aucun service distant ni donnée source.
// Conversions d'octets sans dependance.

export function hexDepuisOctets(octets: Uint8Array): string {
  return Array.from(octets, (o) => o.toString(16).padStart(2, '0')).join('');
}

export function octetsDepuisTexte(texte: string): Uint8Array {
  return new TextEncoder().encode(texte);
}

export function texteDepuisOctets(octets: Uint8Array): string {
  return new TextDecoder().decode(octets);
}

// Copie dans un ArrayBuffer neuf : WebCrypto et IndexedDB refusent parfois une vue partielle.
export function tamponIsole(octets: Uint8Array): ArrayBuffer {
  const copie = new Uint8Array(octets.byteLength);
  copie.set(octets);
  return copie.buffer;
}

export function concatener(morceaux: readonly Uint8Array[]): Uint8Array {
  const total = morceaux.reduce((s, m) => s + m.byteLength, 0);
  const resultat = new Uint8Array(total);
  let position = 0;
  for (const m of morceaux) {
    resultat.set(m, position);
    position += m.byteLength;
  }
  return resultat;
}

// Lecture complete d'un fichier choisi par l'agent (Blob.arrayBuffer, ou FileReader sur un navigateur plus ancien).
export function lireFichier(fichier: Blob): Promise<Uint8Array> {
  if (typeof fichier.arrayBuffer === 'function') {
    return fichier.arrayBuffer().then((b) => new Uint8Array(b));
  }
  return new Promise((resoudre, rejeter) => {
    const lecteur = new FileReader();
    lecteur.onload = () => resoudre(new Uint8Array(lecteur.result as ArrayBuffer));
    lecteur.onerror = () => rejeter(lecteur.error ?? new Error('Lecture du fichier impossible'));
    lecteur.readAsArrayBuffer(fichier);
  });
}
